import React from 'react';

const Brand = ({ href, onClick, className = 'brand-mark' }) => {
  const content = <span className="brand-name">Rebellionaire<span className="brand-ai">.AI</span></span>;
  return href
    ? <a className={className} href={href} aria-label="Rebellionaire.AI" onClick={onClick}>{content}</a>
    : <div className={className} aria-label="Rebellionaire.AI">{content}</div>;
};

export default Brand;
